export default __webpack_public_path__ + "ff8b02e1ef2d4d05c7ee31445787de2b.jpg";